export default {
    'html': {
        name: "html",
        logoColor: "white",
        logo: "html5",
        text: "HTML5",
        bgColor: "E34F26",
    },
    'css': {
        name: "css",
        logoColor: "white",
        logo: "css3",
        text: "CSS3",
        bgColor: "1572B6",
    },
    'javascript': {
        name: "javascript",
        logoColor: "F7DF1E",
        logo: "javascript",
        text: "JavaScript",
        bgColor: "323330",
    },
    'quaggajs': {
        name: "javascript",
        logoColor: "F7DF1E",
        logo: "javascript",
        text: "Quaggajs",
        bgColor: "323330",
    },
    'jquery': {
        name: "jquery",
        logoColor: "white",
        logo: "jquery",
        text: "jQuery",
        bgColor: "0769AD",
    },
    'codeigniter': {
        name: "codeigniter",
        logoColor: "white",
        logo: "codeigniter",
        text: "Codeigniter",
        bgColor: "EF4223",
    },
    'mysql': {
        name: "mysql",
        logoColor: "white",
        logo: "mysql",
        text: "MySQL",
        bgColor: "005C84",
    },
    'vue': {
        name: "vue",
        logoColor: "4FC08D",
        logo: "vuedotjs",
        text: "Vue.js",
        bgColor: "35495E",
    },
    'vuejs': {
        name: "vue",
        logoColor: "4FC08D",
        logo: "vuedotjs",
        text: "Vue.js",
        bgColor: "35495E",
    },
    'vuex': {
        name: "vuex",
        logoColor: "4FC08D",
        logo: "vuedotjs",
        text: "VueX",
        bgColor: "35495E",
    },
    'vue-router': {
        name: "vue-router",
        logoColor: "4FC08D",
        logo: "vuedotjs",
        text: "Vue-router",
        bgColor: "4FC08D",
    },
    'typescript': {
        name: "typescript",
        logoColor: "white",
        logo: "typescript",
        text: "TypeScript",
        bgColor: "007ACC",
    },
    'twilio': {
        name: "twilio",
        logoColor: "white",
        logo: "Twilio",
        text: "Twilio",
        bgColor: "F22F46",
    },
    'paypal': {
        name: "paypal",
        logoColor: "white",
        logo: "paypal",
        text: "PayPal",
        bgColor: "00457C",
    },
    'stripe': {
        name: "stripe",
        logoColor: "white",
        logo: "Stripe",
        text: "Stripe",
        bgColor: "626CD9",
    },
}